import { css } from 'emotion';

export const periodContainer = css`
  display: flex;
  flex-direction: column;
`;

export const pickerWrapper = css`
  display: flex;
  flex-direction: row;
  margin: 0;
  flex-wrap: wrap;
  align-items: center;
`;

export const radioGroup = css`
  align-self: flex-start;
  margin-right: 30px;
  align-items: end;
  margin-top: 12px;

  && {
    display: flex;
    flex-direction: row;
  }

  & > *:not(:first-of-type) {
    margin-left: 30px;
  }
`;

export const pickerPeriod = css`
  max-width: 348px;
`;

export const pickerDate = css`
  max-width: 150px;
  margin-bottom: 20px;
`;

export const errorWrapper = css`
  height: 20px;
  margin-left: 198px;
`;
